import { ApiLinkEntity, ApiLinkRel } from "config/constants"
import { Guid, IApiLink } from "@/types"

export interface IDepreciationMatrixItem {
    restDurationMonths: number
    depreciationRate?: number | null
}

export interface IDepreciationMatrixException {
    id: Guid,
    description: string
}

export interface IGetDepreciationMatrixDto {
    persisted: boolean
    assetCategoryId: Guid
    equipment?: IDepreciationMatrixItem[] | null
    machine?: IDepreciationMatrixItem[] | null
    exceptionArticles?: IDepreciationMatrixException[] | null
    links: IApiLink[]
}

export interface IPostDepreciationMatrixDto {
    equipment: IDepreciationMatrixItem[]
    machine: IDepreciationMatrixItem[]
}

export interface IGetExceptionDepreciationMatrixDto {
    assetCategoryId: Guid
    articleId: Guid
    entities?: IDepreciationMatrixItem[] | null
    links: IApiLink[]
}

export interface IPostExceptionDepreciationMatrixDto {
    entities: IDepreciationMatrixItem[]
}

export class DepreciationMatrix {

    persisted: boolean
    assetCategoryId: Guid
    equipment: IDepreciationMatrixItem[] | null
    machine: IDepreciationMatrixItem[] | null
    exceptionArticles: IDepreciationMatrixException[] | null
    linkCreate?: IApiLink
    linkUpdate?: IApiLink
    linkGetException?: IApiLink
    linkCreateException?: IApiLink

    constructor(dto: IGetDepreciationMatrixDto) {
        this.persisted = dto.persisted
        this.assetCategoryId = dto.assetCategoryId
        this.equipment = dto.equipment ?? null
        this.machine = dto.machine ?? null
        this.exceptionArticles = dto.exceptionArticles?.sort((a, b) => a.id.localeCompare(b.id)) ?? null
        this.linkCreate = dto.links.find(lnk => lnk.entity === ApiLinkEntity.assetCategoryDepreciation && lnk.rel === ApiLinkRel.create)
        this.linkUpdate = dto.links.find(lnk => lnk.entity === ApiLinkEntity.assetCategoryDepreciation && lnk.rel === ApiLinkRel.update)
        this.linkGetException = dto.links.find(lnk => lnk.entity === ApiLinkEntity.articleDepreciation && lnk.rel === ApiLinkRel.all)
        this.linkCreateException = dto.links.find(lnk => lnk.entity === ApiLinkEntity.articleDepreciation && lnk.rel === ApiLinkRel.create)
    }

    toPostDto(): IPostDepreciationMatrixDto {
        return {
            equipment: this.equipment ?? [],
            machine: this.machine ?? []
        }

    }
}

export class ExceptionDepreciationMatrix {
    assetCategoryId: Guid
    articleId: Guid
    entities: IDepreciationMatrixItem[] | null
    linkUpdate?: IApiLink

    constructor(dto: IGetExceptionDepreciationMatrixDto) {
        this.assetCategoryId = dto.assetCategoryId
        this.articleId = dto.articleId
        this.entities = dto.entities ?? null
        this.linkUpdate = dto.links.find(lnk => lnk.entity === ApiLinkEntity.articleDepreciation && lnk.rel === ApiLinkRel.update)
    }

    toPostDto(): IPostExceptionDepreciationMatrixDto {
        return {
            entities: this.entities ?? [],
        }

    }
}
